import { createContext, useState, useEffect } from "react";
import { processInventory } from "./processing";

export const AppContext = createContext(null);

const AppContextProvider = ({ children }) => {
  const [inventory, setInventory] = useState(null);
  const [validation, setValidation] = useState(null);
  const [activeStore, setActiveStore] = useState(null);
  const [activeProduct, setActiveProduct] = useState(null);
  const [processingError, setProcessingError] = useState(null);

  const showUpload = !inventory || validation !== false;
  const showValidation = inventory && validation !== false;
  const showProceedToStore = inventory && validation === false && !activeStore; 
  const showStore = inventory && validation === false && activeStore && !activeProduct;
  const showProduct = inventory && validation === false && activeStore && activeProduct;
  const resetInventory = () => {
    setInventory(null);
    setActiveStore(null);
    setActiveProduct(null);
    setProcessingError(null);
  };

  const globalStack = {
    inventory,
    setInventory,
    activeStore,
    setActiveStore,
    activeProduct,
    setActiveProduct,
    validation,
    setValidation,
    processingError,
    showUpload,
    showValidation,
    showProceedToStore,
    showStore,
    showProduct,
    resetInventory,
  };

  useEffect(() => {
    if (!inventory) {
      setValidation(null);
      return;
    }

    try{
      const validation = processInventory(inventory)
      setValidation(validation)
    }
    catch(e) {
      setProcessingError(e)
    }
  }, [inventory]);

  return (
    <AppContext.Provider value={globalStack}>{children}</AppContext.Provider>
  );
};

export { AppContextProvider };
